module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc26-33828f459982599b6098fbb86895d88e.jpg";